import React from 'react';

import Packages from './catering-landing-packages';
import { CateringLandingPackageSection } from './CateringLandingPackageSection';

export const CateringLandingPackageSections = () => {
  const packageSections = [
    {
      title: 'Perfect for production',
      id: 'perfect-for-production',
      subheader: 'Offering a range from light snacks to hearty, filling options to keep everyone focused and happy.',
      packages: Packages.slice(0, 3),
      backgroundColor: '#F8F9FA'
    },
    {
      title: 'Photo-worthy events',
      id: 'photo-worthy-events',
      subheader: 'These options are as beautiful as they are delicious, guaranteed to impress all of your guests.',
      packages: Packages.slice(3, 6),
      backgroundColor: '#FFFFFF'
    },
    {
      title: 'Ideal for meetings',
      id: 'ideal-for-meetings',
      subheader: 'Classic, tasty, and easily shareable, these spreads will elevate any work function.',
      packages: Packages.slice(6),
      backgroundColor: '#F8F9FA'
    }
  ];

  return packageSections.map((section) => (
    <CateringLandingPackageSection
      key={section.title}
      {...section}
    />
  ));
};
